import React from "react";
import { Button } from "@sscs/ui";
import { CancelIcon } from "@sscs/ui/icons";
import { Dialog } from "Components";
import { useDialog } from "Hooks";
import { useGetWhoamiQuery } from "Services";
import useRevokeAllAccessToken from "../../hooks/useRevokeAllAccessTokens";

type RevokeAllAccessTokensProps = {
  isDisabled: boolean;
};

const RevokeAllAccessTokens = ({
  isDisabled,
}: RevokeAllAccessTokensProps): React.JSX.Element => {
  const { data: whoami } = useGetWhoamiQuery();

  const revokeAllDialog = useDialog();

  const { handleRevokeAllAccessTokens } = useRevokeAllAccessToken({
    userId: whoami?.user_id,
    onClose: revokeAllDialog.close,
  });

  return (
    <>
      <Button
        onClick={revokeAllDialog.open}
        disabled={isDisabled}
        color="secondary"
      >
        <CancelIcon />
        Revoke all tokens
      </Button>

      <Dialog
        title="Revoke all personal access tokens"
        confirmText="Revoke"
        isOpen={revokeAllDialog.isOpen}
        onCancel={revokeAllDialog.close}
        onClose={revokeAllDialog.close}
        onConfirm={handleRevokeAllAccessTokens}
        cancelButtonColor="primary"
        confirmButtonColor="error"
        dangerZone="revoke-all"
      >
        <span>
          Are you sure you want to revoke all your personal access tokens?
        </span>
      </Dialog>
    </>
  );
};

export default RevokeAllAccessTokens;
